import type { RouteRecord } from "vite-react-ssg";

// These routes remain client-rendered and keep their page-level RequireAuth guards.
// Parent and page modules can load in parallel, without Query on public routes.
export const accountRoute = {
  path: "account",
  lazy: async () => ({
    Component: (await import("@/components/account/AccountQueryBoundary")).default,
  }),
  children: [
    { path: "subscription/withdrawal", lazy: async () => ({ Component: (await import("@/pages/AccountWithdrawal")).default }) },
    {
      path: "subscription",
      lazy: async () => ({ Component: (await import("@/pages/AccountSubscription")).default }),
    },
    {
      path: "subscription/scales",
      lazy: async () => ({ Component: (await import("@/pages/AccountSubscriptionScales")).default }),
    },
    {
      index: true,
      lazy: async () => ({ Component: (await import("@/pages/Account")).default }),
    },
    {
      path: "orders",
      lazy: async () => ({ Component: (await import("@/pages/AccountOrders")).default }),
    },
    {
      path: "products",
      lazy: async () => ({ Component: (await import("@/pages/AccountProducts")).default }),
    },
    {
      path: "products/buy-data-package",
      lazy: async () => ({ Component: (await import("@/pages/BuyDataPackage")).default }),
    },
    {
      path: "products/buy-data-package/success",
      lazy: async () => ({ Component: (await import("@/pages/BuyDataPackageSuccess")).default }),
    },
    {
      path: "products/:id",
      lazy: async () => ({ Component: (await import("@/pages/AccountProductDetail")).default }),
    },
  ],
} satisfies RouteRecord;
